import { gql } from '@apollo/client';

export const DELETE_DATA_IMPORTER = gql`
    mutation deleteDataImporter($id: ID!) {
        facility {
            configurations {
                dataImporters {
                    delete(input: { id: $id })
                }
            }
        }
    }
`;
